/**
 * @desc 订单取消
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderFacadeImpl.cancelOrder.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/cancelOrder`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
